import { db } from '../utils/configureFirebase';

export const getBillTracks = (cb) => {
  const unsubscribe = db.collection('billTrack').onSnapshot((snapshot) => {
    const billTrack = [];
    snapshot.forEach((doc) => {
      billTrack.push(doc.data());
    });
    cb(billTrack);
  });
  return unsubscribe;
};

export const getAmendmentsForBill = (billID, cb) => {
  const unsubscribe = db
    .collection('billTrack')
    .doc(billID)
    .collection('amendments')
    .onSnapshot((snapshot) => {
      const amendments = [];
      snapshot.forEach((doc) => {
        amendments.push(doc.data());
      });
      cb(amendments);
    });
  return unsubscribe;
};

export const getBillTrackWithId = async (billID) => {
  const billDoc = await db
    .collection('billTrack')
    .doc(billID)
    .get();

  if (!billDoc.exists) {
    throw new Error('Invalid Bill');
  }
  const billData = billDoc.data();
  return { data: billData };
};



// WEBPACK FOOTER //
// ./src/services/billTrackServices.js